import { Tooltip as AntdTooltip, type TooltipProps } from "antd"

const Basic = ({
	color = "var(--color-white)",
	classNames = { container: "text-navy-100" },
	...props
}: TooltipProps) => (
	<AntdTooltip {...props} color={color} classNames={classNames} />
)

const Dark = ({
	color = "var(--color-grey-90)",
	placement = "bottom",
	classNames = { container: "text-white" },
	...props
}: TooltipProps) => {
	return (
		<AntdTooltip
			{...props}
			color={color}
			classNames={classNames}
			placement={placement}
		/>
	)
}

export const Tooltip = Object.assign(Basic, {
	Dark,
})
